import "./ServiceGallery.css";

const ServiceGallery = ({ data }) => {
  return (
    <section className="service1-gallery">
      <div className="gallery1-container">
        <div className="gallery2-heading">
          <span className="section-tag-gallery">
            {data.gallerySection?.tag || "FEATURED PROJECTS"}
          </span>

          <h2>{data.gallerySection?.title}</h2>

          <p>{data.gallerySection?.description}</p>
        </div>

        <div className="service1-gallery-grid">
          {data.gallery.map((project, index) => (
            <div className="service1-gallery-card" key={index}>
              <img src={project.image} alt={project.title} />

              <div className="service1-gallery-overlay">
                <span className="project-year">{project.year}</span>

                <h3>{project.title}</h3>

                <p>📍 {project.location}</p>

                <span className="project-surface">{project.surface}</span>

                {/* <button>View Project →</button> */}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default ServiceGallery;
